export default {
  activity: {
    cycleCount: "活动周期",
    enable: "立即启用",
    consumeTime: "领取时间",
    expendStatus: "状态",
    awardAmountTotal: "累计奖励金额",
    platform: "平台",
    platformSet: "配置平台活动",
    option: "操作",
    operatorTime: "操作时间",
    remark: "备注",
    copySuccess: "复制成功",
    pasteSuccess: "粘贴成功",
    reset: "重置",
    submit: "提交",
    explain: "说明",
    time: "时间",
    title: "标题",
    subtitle: "副标题",
    copy: "复制",
    paste: "粘贴",
    delete: "删除",
    version: "Phiên bản",
    amount: 'số tiền',
    code: 'mã số khuyến mãi',
    codeAndName: 'số / tên sự kiện',
    name: 'tên khuyến mãi',
    icon: "biểu tượng hoạt động",
    uploadIcon: "Vui lòng tải lên biểu tượng hoạt động",
    content: 'nội dung',
    sort: 'loại',
    effectiveTime: 'Thời gian có hiệu lực',
    config: 'cấu hình',
    blacklist: 'danh sách đen',
    restart: 'bắt đầu lại',
    ongoing: 'đang tiến hành',
    stop: 'dừng lại',
    overdue: 'Hết hạn',
    disbale: "danh mục cấm",
    cancelBlack: 'hủy bỏ danh sách đen',
    batchCancelBlack: 'Hủy bỏ danh sách đen hàng loạt',
    awardNum: 'Số lượng giải thưởng',
    totalAward: 'tích lũy thưởng',
    totalRecharge: 'Tích lũy nạp tiền',
    totalRechargeDay: 'Tích lũy số ngày nạp tiền',
    rechargeAmount: 'Số tiền nạp',
    lossAmount: 'Số tiền thua',
    consumptionAmount: 'Hủy bỏ số tiền',
    efficientNum: 'Số người hiệu quả',
    inviteNum: 'Số lượng người được mời',
    signDay: 'số ngày điểm danh',
    consumption: "lượng cược",
    withdrawStint: 'Rút tiền cược',
    games: 'Trò chơi áp dụng',
    award: 'số tiền thưởng',
    remainConsumption: "lượng cược còn lại",
    withdrawConsumption: 'tiền cược thực tế',
    withdrawState: 'trạng thái',
    withdrawStateRunning: 'đang cược',
    withdrawStateWait: 'chờ đặt cược',
    withdrawStateComplete: 'hoàn thành đặt cược',
    effectiveUserConfig: 'Cài đặt người dùng hiệu quả',
    withdrawCompleteType: "Mở khóa phương pháp",
    withdrawCompleteType1: "người sử dụng",
    withdrawCompleteType2: "người quản lý",
    conditions: 'điều kiện khuyến mãi',
    allowSame: 'cho phép giống nhau',
    unAllowSame: 'không cho phép giống nhau',
    bankCard: 'tài khoản ngân hàng',
    open: 'bắt đầu khuyến mãi',
    close: 'khuyến mãi kết thú',
    status: "Trạng thái hoạt động",
    status2: "已过期",
    status1: "禁用",
    status0: "启用",
    signInTime: 'thời gian điểm danh',
    lineGames: "trò chơi",
    groupGames: "Trò chơi hoạt động",
    defaultGame: "chuyển hướng trò chơi",
    noSetting: "Chưa có cấu hình hoạt động",
    inviteUserCount: "Người dùng được mời đã tích lũy",
    selectGame: "chọn trò chơi",
    selectPage: "chọn giao diện",
    tip: {
      delete: "Bạn có chắc chắn sẽ xóa dữ liệu lựa chọn không? Sau khi xóa, bạn cần lưu cấu hình để có hiệu lực.",
      awardAmount: "请输入大于1小于等于15位的整数",
      enable: "更改配置后请先【提交】活动配置，活动状态将改为禁用状态，如需立即启用请点击【立即启用】按钮",
      cycleCount: "请输入大于0小于99999的整数",
    },
    seriesWin: {
      reachAmount: "连续赢订单数",
      reachConditionOne: "投注金额/单笔≥",
      reachConditionTwo: "连续赢金额/单笔≥",
    },
    seriesLost: {
      reachAmount: "连续输订单数",
      reachConditionOne: "投注金额/单笔≥",
      reachConditionTwo: "连续输金额/单笔≥",
    },
  }
}
